import { jsx as l } from "react/jsx-runtime";
import { useContext as o } from "react";
import { cn as a } from "./designsystem-ui-react47.js";
import { CardContext as m } from "./designsystem-ui-react62.js";
function u({
  as: t = "h3",
  size: e = "responsive",
  className: n,
  children: r
}) {
  const { isLink: i, variant: s } = o(m);
  return /* @__PURE__ */ l(
    t,
    {
      className: a(
        "tw-leading-tight tw-m-0 tw-line-clamp-2 @xl:tw-line-clamp-3 tw-font-medium",
        {
          small: "tw-text-base",
          medium: "tw-text-lg",
          large: "tw-text-xl",
          responsive: "tw-text-lg @sm:tw-text-xl"
        }[e],
        s === "inverted" ? "tw-text-ink-brand-inverted" : "tw-text-ink-brand-default",
        i && "group-hover:tw-underline tw-underline-offset-4",
        n
      ),
      children: r
    }
  );
}
export {
  u as CardTitle
};
